import { Chip as MuiChip, ChipProps as MuiChipProps, chipClasses } from '@mui/material'
import styled from 'styled-components'
import { space, SpaceProps } from 'styled-system'

export type ChipPropsType = MuiChipProps & SpaceProps
export { chipClasses }

const Chip = styled(MuiChip)<ChipPropsType>`
  ${space}

  font-weight: 700;
`

export default Chip
